<div class="item" *ngFor="let item of allPosiibleAnswers" fxLayout="row" fxLayoutAlign="start center">
  <p class="percentage">{{ item.percentage }}%</p>
  <mat-progress-bar [value]="item.percentage"></mat-progress-bar>
  <p class="value">{{ item.name }}</p>
</div>
